/**
 * Inverio Logo Assets
 *
 * Centralized logo references. Use these instead of hardcoded URLs or
 * inline require() calls so every screen stays in sync.
 */

/** App icon / mark — works on any background */
export const LOGO_MARK = require('../../assets/images/logo_app.png');

/** Full wordmark — white text, for dark / teal / gradient backgrounds */
export const LOGO_WORDMARK_WHITE = require('../../assets/images/logo_inverio_white.png');

/** Full wordmark — dark text on transparent, for light backgrounds */
export const LOGO_WORDMARK_LIGHT = require('../../assets/images/logo_inverio_transparent.png');

/** Full wordmark — full-color version */
export const LOGO_WORDMARK_COLOR = require('../../assets/images/logo_inverio.png');
